export default __webpack_public_path__ + "static/media/kr.9406f22f.svg";